import React from "react";
import EliteSpinner from "./EliteSpinner.js";
import DropdownTheme from "./DropdownTheme";
import { IconContext } from "react-icons";
import { TbBorderLeft, TbPencil, TbPencilOff } from "react-icons/tb";
import { FiShare2 } from "react-icons/fi";
import "./Eval.css";
import "../fonts/Modenine-2OPd.ttf";
import OpenAI from "./images/openai.png";
import HuggingFace from "./images/huggingfaceicon.png";
import anthropic from "./images/anthropic.png";
import GrokAI from "./images/GrokAI.png";
import Gemini from "./images/Google-Gemini.webp";
import Copilot from "./images/github-copilot.png";

class Eval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: this.props.code,
      language_id: this.props.language_id,
      token: this.props.token,
      evalOutput: this.props.evalOutput,
      evalOutputDB: this.props.evalOutputDB,
      memory: this.props.memory,
      time: this.props.time,
      loading: this.props.loading,
      sessionid: this.props.sessionid,
      mode: "plain",
      compileOutput: this.props.compileOut,
      evalExtend: this.props.evalExtend,
      errOutput: this.props.errOutput,
      flanT5Toggle: this.props.flanT5Toggle,
      anthropicToggle: this.props.anthropicToggle,
      PaLMToggle: this.props.PaLMToggle,
      GeminiToggle: this.props.GeminiToggle,
      GrokAIToggle: this.props.GrokAIToggle,
      theme: [
        {
          id: 0,
          mode: "plain",
          key: "theme",
          title: "Plain",
          selected: false,
        },
        {
          id: 1,
          mode: "terminal",
          key: "theme",
          title: "Terminal",
          selected: false,
        },
      ],
      currTheme: "Plain",
    };
    this.toggleTheme = this.toggleTheme.bind(this);
    this.runCodeEval = this.runCodeEval.bind(this);
  }

  componentDidMount() {
    const keysToGet = ["keyTheme", "mode", "currTheme", "compileOutput", "evalOutput"];

    const stateUpdate = keysToGet.reduce((acc, key) => {
      acc[key] = sessionStorage.getItem(key);
      return acc;
    }, {});

    this.setState(stateUpdate);

    // Browser detection for Safari
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      document.body.classList.add('safari');
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.code !== prevState.code ||
      nextProps.language_id !== prevState.language_id ||
      nextProps.token !== prevState.token ||
      nextProps.evalOutput !== prevState.evalOutput ||
      nextProps.evalOutputDB !== prevState.evalOutputDB ||
      nextProps.memory !== prevState.memory ||
      nextProps.time !== prevState.time ||
      nextProps.loading !== prevState.loading ||
      nextProps.sessionid !== prevState.sessionid ||
      nextProps.compileOut !== prevState.compileOutput ||
      nextProps.evalExtend !== prevState.evalExtend ||
      nextProps.errOutput !== prevState.errOutput ||
      nextProps.flanT5Toggle !== prevState.flanT5Toggle ||
      nextProps.anthropicToggle !== prevState.anthropicToggle ||
      nextProps.PaLMToggle !== prevState.PaLMToggle ||
      nextProps.GeminiToggle !== prevState.GeminiToggle ||
      nextProps.GrokAIToggle !== prevState.GrokAIToggle
    ) {
      return {
        code: nextProps.code,
        language_id: nextProps.language_id,
        token: nextProps.token,
        evalOutput: nextProps.evalOutput,
        evalOutputDB: nextProps.evalOutputDB,
        memory: nextProps.memory,
        time: nextProps.time,
        loading: nextProps.loading,
        sessionid: nextProps.sessionid,
        compileOutput: nextProps.compileOut,
        evalExtend: nextProps.evalExtend,
        errOutput: nextProps.errOutput,
        flanT5Toggle: nextProps.flanT5Toggle,
        anthropicToggle: nextProps.anthropicToggle,
        PaLMToggle: nextProps.PaLMToggle,
        GeminiToggle: nextProps.GeminiToggle,
        GrokAIToggle: nextProps.GrokAIToggle,
      };
    }
    return null;
  }

  onKeyUp(keyName, e, handle) {
    console.log("test:onKeyUp", e, handle);
    this.setState({
      output: `onKeyUp ${keyName}`,
    });
  }

  onKeyDown(keyName, e, handle) {
    console.log("test:onKeyDown", keyName, e, handle);
    this.setState({
      output: `onKeyDown ${keyName}`,
    });
    this.runCode();
  }

  toggleTheme(id, key, mode) {
    let temp = this.state[key];
    temp[id].selected = !temp[id].selected;
    let newMode = this.state[key][id];
    this.setState({
      [key]: temp,
      mode: newMode["mode"],
      currTheme: newMode["title"],
    });
    sessionStorage.setItem("keyTheme", temp);
    sessionStorage.setItem("modeTheme", newMode["mode"]);
    sessionStorage.setItem("currTheme", newMode["title"]);
  }

  runCodeEval = () => {
    this.props.runCode();
  }

  renderOutput = (output) => {
    // Only render output if it is not null, undefined, or the string 'null'
    const { mode } = this.state;
    const themeClass = mode === 'terminal' ? 'output-container-terminal' : 'output-container-plain';
    if (output === null || output === undefined || output === "null") {
      return <div className={`output-container ${themeClass}`}>Terminal output here.</div>;
    }
    return (
      <div className={`output-container ${themeClass}`}>
        {output}
      </div>
    );
  };

  renderWithScroll = (output) => {
    return (
      <div className="scroll-container">
        {this.renderOutput(output)}
      </div>
    );
  };

  render() {
    // Get output from props first, then fall back to sessionStorage
    const evalOutput = this.props.evalOutput || sessionStorage.getItem("evalOutput");
    const sessionOutput = sessionStorage.getItem("evalOutput");
    const loading = this.props.loading;
    const time = this.props.time;
    const memory = this.props.memory;
    const evalOutputDB = this.props.evalOutputDB;

    const conditionalRender = () => {
      if (loading) return <EliteSpinner />;

      // First try to render from props
      if (evalOutput !== null && evalOutput !== undefined && evalOutput !== "null") {
        return this.renderWithScroll(this.renderOutput(evalOutput));
      }

      // Then try to render from database
      if (evalOutputDB !== null && evalOutputDB !== undefined && evalOutputDB !== "null") {
        return this.renderWithScroll(this.renderOutput(evalOutputDB));
      }

      // Finally try to render from session storage
      if (sessionOutput !== null && sessionOutput !== undefined && sessionOutput !== "null") {
        return this.renderWithScroll(this.renderOutput(sessionOutput));
      }

      // If nothing is available, show default message
      return <p className="codeRes-plain">Terminal output here.</p>;
    };

    const timeRender = () => {
      if (time) {
        return <div className="memory">Time: {time}s Memory: {memory} kb</div>
      }
    };

    const shareIcon = () => {
      const { openShareModal } = this.props;

      return (
        <div
          className="extendBtn"
          onClick={openShareModal}
          title="Share this sandbox"
        >
          <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
            <FiShare2 />
          </IconContext.Provider>
        </div>
      );
    };

    const timerIcon = () => {
      const { currTheme } = this.state;

      return (
        <div>
          <div className="timerDiv">
            {openAiIcon()}
            {GrokAIIcon()}
            {GeminiIcon()}
            {huggingFaceIcon()}
            {anthropicIcon()}
            {completionsIcon()}
            {borderIcon()}
            {shareIcon()}
          </div>
        </div>
      );
    };

    const whiteboardIcon = () => {
      const { whiteboardExtend, toggleWhiteboard } = this.props;

      const Icon = whiteboardExtend ? TbPencilOff : TbPencil;

      return (
        <div title="whiteboard" className="extendBtn" onClick={toggleWhiteboard}>
          <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
            <Icon />
          </IconContext.Provider>
        </div>
      );
    };

    const openAiIcon = () => {
      const { openAiToggle, toggleOpenAI } = this.props;

      return (
        <div className="extendBtn" onClick={toggleOpenAI}>
          <img
            title="OpenAI"
            className={openAiToggle ? "openai" : "openai-off"}
            src={OpenAI}
            alt="openai"
          />
        </div>
      );
    };

    const borderIcon = () => {
      const { whiteboardExtend, toggleBorder } = this.props;

      if (!whiteboardExtend) return null;

      return (
        <div className="extendBtn" onClick={toggleBorder}>
          <IconContext.Provider value={{ size: "1.35em", style: { paddingRight: "0.2rem", marginTop: "0.1rem" } }}>
            <TbBorderLeft />
          </IconContext.Provider>
        </div>
      );
    };

    const completionsIcon = () => {
      const { completionToggle, toggleCompletion } = this.props;

      return (
        <div className="extendBtn" onClick={toggleCompletion}>
          <img
            title="Copilot"
            className={completionToggle ? "openai" : "openai-off"}
            src={Copilot}
            alt="Copilot"
          />
        </div>
      );
    };

    const huggingFaceIcon = () => {
      const { flanT5Toggle, toggleFlanT5 } = this.props;

      return (
        <div className="extendBtn" onClick={toggleFlanT5}>
          <img
            title="Huggingface"
            className={flanT5Toggle ? "openai" : "openai-off"}
            src={HuggingFace}
            alt="huggingface"
          />
        </div>
      );
    };

    const anthropicIcon = () => {
      const { anthropicToggle, toggleAnthropic } = this.props;

      return (
        <div className="extendBtn" onClick={toggleAnthropic}>
          <img
            title="Anthropic"
            className={anthropicToggle ? "openai" : "openai-off"}
            src={anthropic}
            alt="anthropic"
          />
        </div>
      );
    };

    const GeminiIcon = () => {
      const { GeminiToggle, toggleGemini } = this.props;

      return (
        <div className="extendBtn" onClick={toggleGemini}>
          <img
            title="Google Gemini"
            className={GeminiToggle ? "openai" : "openai-off"}
            src={Gemini}
            alt="Gemini"
          />
        </div>
      );
    };

    const GrokAIIcon = () => {
      const { GrokAIToggle, toggleGrokAI } = this.props;

      return (
        <div
          className="extendBtn"
          onClick={() => {
            // console.log("Grok AI icon clicked, current state:", GrokAIToggle);
            toggleGrokAI();
          }}
        >
          <img
            title="Grok AI"
            className={GrokAIToggle ? "openai" : "openai-off"}
            src={GrokAI}
            alt="Grok AI"
          />
        </div>
      );
    };

    const { darkMode } = this.props;
    const { theme } = this.state;
    return (
      <div className="evalOut">
        {conditionalRender()}
        <div>
          {timeRender()}
          {timerIcon()}
          <button
            id="runButton"
            className={`btn ${darkMode ? "letsRun-dark" : "letsRun"}`}
            onClick={this.runCodeEval}
          >
            Run
          </button>
          <DropdownTheme
            toggleItem={this.toggleTheme}
            title="Theme "
            theme={theme}
          />
        </div>
      </div>
    );
  }
}

export default Eval;
